import { markRaw } from 'vue';

import SelectDomain from './modules/SelectDomain.vue';
import VerifyRecords from './modules/VerifyRecords.vue';

export type Module = {
  id: string;
  component: any;
};

export type Section = {
  id: string;
  label: string;
  modules: Module[];
};

export default [
  {
    id: 'selectDomain',
    label: 'Select Domain',
    modules: [{ id: 'selectDomain', component: SelectDomain }]
  },
  {
    id: 'verifyRecords',
    label: 'Update your DNS records',
    modules: [{ id: 'verifyRecords', component: markRaw(VerifyRecords) }]
  }
];
